import { ref, type Ref } from 'vue';
import { defineStore } from 'pinia';
import merge from 'lodash/merge';
import { customDeepClone } from '@core';
import type { ModuleConfig, ModuleConfigPartial } from '../models';
import { createDefaultModuleConfig } from '../utils';

export const useModulesConfigStore = defineStore('modulesConfigStore', () => {
  const moduleConfig: Ref<ModuleConfig> = ref(createDefaultModuleConfig());

  const setModuleConfig = (partialModuleConfig: ModuleConfigPartial) => {
    const defaultConfig = customDeepClone(createDefaultModuleConfig());

    const mergedConfig = merge(defaultConfig, partialModuleConfig) as ModuleConfig;

    if (partialModuleConfig.plan?.planTypeOptions) {
      mergedConfig.plan.planTypeOptions = partialModuleConfig.plan.planTypeOptions;
    }

    if (partialModuleConfig.plan?.doseTypeOptions) {
      mergedConfig.plan.doseTypeOptions = partialModuleConfig.plan.doseTypeOptions;
    }

    if (partialModuleConfig.plan?.availableDownloadFormats) {
      mergedConfig.plan.availableDownloadFormats = partialModuleConfig.plan.availableDownloadFormats;
    }

    moduleConfig.value = mergedConfig;
  };

  return {
    moduleConfig,
    setModuleConfig
  };
});
